export const RestrictedDomains=[
    "tcmtotal.in",
    "teamtrans.in",
    "tirangagroup.in",
    "tapl.biz",
    "totallogitics.in",
    "transxpresslogistics.com",
    "transitech.in",
    "ti-3pl.com",
    "tclpl.com",
    "transwellexpress.com",
    "in.dsv.com",
    "vrllogistics.com",
    "uever.com",
    "KPTML.COM",
    "gmail.com",
    "golcha.com",
    "flyjac.com",
    "glovis.co.in",
    "delhivery.com",
    "gozefo.com",
    "shreeguruji.com",
    "globemoving.net",
    "netafim.co.in",
    "yahoo.co.in",
    "MYSTICSHIPPING.COM",
    "nordex-online.com",
    "nic.in",
    "rediffmail.com",
    "mehruelecricals.com",
    "hotmail.com",
    "tcpl.com",
    "yahoo.in",
    "mail.sfl.co.in",
    "pml.poloron.in",
    "adlindia.com",
    "yahoo.com",
    "mmcoco.com",
    "yahoo.co.uk",
    "captiv.biz",
    "sandfits.com",
    "systechitsolutions.co.in",
    "holisolindia.com",
    "gmail.com ",
    "calibershipping.com",
    "careclearing.com",
    "ymail.com",
    "vishwajeetlogistics.in",
    "rogersworldwideindia.com",
    "siddharthalogistics.com",
    "enlivenindia.co.in",
    "scoi.in",
    "surendratransport.com",
    "swatigroup.net.in",
    "mastangroup.in",
    "tcihi-ways.com",
    "vishaka.in",
    "lesso.com",
    "dongkook.com",
    "bhilosa.com",
    "qwerty.com",
    "dame.com",
    "inianoil.in",
    "ecomexpress.in",
    "luthraindia.com",
    "xyz.com",
    "abc.com",
    "imfa.in",
    "delhvery.com",
    "flywheel.in",
    "saglobal.in",
    "everestin.com",
    // "kuehne-nagel.com",
    "scj.in",
    "alpoverseas.com",
    "novares.com",
    "rjcorp.com",
    "acedesigners.co.in",
    "gatikwe.com",
    "safexpress.com",
    "4tigo.com",
    "indiacaronltd.com",
    "signify.com",
    "nagwan.net",
    "sreeniketana.com",
    "EXCELMARITIME.IN",
    "bindyacargo.com",
    "shreeshippingservices.com",
    "pragatilogistics.com",
    "procamlogistics.com",
    "chartered.co.in",
    "aaryalogisticssolutions.com",
    "newbharatgolden.blogspot.in",
    "prclimited.co.in",
    "mdmovers.in",
    "transportguru.in",
    "western-carriers.com",
    "maplelogistics.com",
    "rebagroup.in",
    "tirangalogistics.com",
    "rcclimited.in",
    "vijaylogistics.com",
    "blackbuck.com",
    "mrcindia.com",
    "abhinavtransindia.co.in",
    "ndlogisticspltd.com",
    "cci-logistics.com",
    "barodafreightcarrier.in",
    "globeecologistics.com",
    "atol.co.in",
    "grcpl.in",
    "pawantransport.in",
    "spgolden.com",
    "apllogistics.com",
    "interindiagroup.com",
    "btplindia.in",
    "ritcologistics.com",
    "ntclogistics.in",
    "shivanicarriers.com",
    "futuretrucks.in",
    "glasswing.in",
    "rcilogistics.co.in",
    "ganeshroadlines.com",
    "ACCURATEFREIGHT.IN",
    "WESTCONG.COM",
    "GROUPINLAND.COM",
    "flyinggreen.co.in",
    "gicl.co",
    "girlogistics.in",
    "sanatanlogistics.com",
    "globeexpresstrco.com",
    "westroadways.com",
    "radhikacarriers.in",
    "eliteroadways.com",
    "ADLPL.COM",
    "ptcodisha.com",
    "Southerncargo.in",
    "sugamgroup.com",
    "ASHWINILOGISTICS.IN",
    "navata.com",
    "efclogistics.com",
    "gobolt.in",
    "ssrc.co",
    "singhroadcarriers.com",
    "reematransport.com",
    "hariomfreight.com",
    "gntlogistics.co",
    "adarshrpl.com",
    "crimsonlogistics.net",
    "utccarriers.com",
    "coldstarlogistics.com",
    "shreehatkeshwara.com",
    "bhavnaroadways.com",
    "deepakroadlines.com",
    "sahararoadlines.com",
    "vikasroadcarriers.com",
    "thetrailortransport.com",
    "assambombaycarriers.com",
    "sgtc.in",
    "rbtpl.com",
    "jaintransport.com",
    "jptransport.co.in",
    "rrroadwayspvtltd.com",
    "rajeshrpl.in",
    "srpl.net.in",
    "ttclogistics.net",
    "superindia.co.in",
    "goldentransport.in",
    "alpl.co.in",
    "shridineshgroup.com",
    "babaroadlines.com",
    "vinayakbulkmovers.com",
    "patel-india.com",
    "vishalroadlines.co.in",
    "voratransport.co.in",
    "vrlgroup.in",
    "newwesterncarrier.in",
    "ewro.in",
    "drllogistics.com",
    "crescentroadwayspvtltd.com",
    "sreevinayakatrailerservices.com",
    "nehatransport.com",
    "vltc.in",
    "shreesalasar.in",
    "balroadlines.com",
    "acplcargo.com",
    "agarwalpackers.in",
    "mlpl.biz",
    "choudharytransport.com",
    "southcarryingcorporation.in",
    "hgts.in",
    "salasarlogistic.com",
    "satgurucarrier.com",
    "shreeshyamroadlink.com",
    "roshantransport.com",
    "raghojitransport.com",
    "unionroadwaysltd.com",
    "anandudyogsamuh.com",
    "gangatransport.com",
    "KAPOORDIESELS.COM",
    "omlogistics.co.in",
    "PRCPL.COM",
    "JAIDURGATRANSPORT.COM",
    "PBRPITHAMPUR.COM",
    "abhinavtranscargo.com",
    "PPTL.CO.IN",
    "bharatroad.com",
    "UNILOG.CO.IN",
    "VBGOLDEN.COM",
    "TMCARRIERS.COM",
    "thevisionhouse.in",
    "avglogistics.com",
    "UNION ROADWAYS LTD.COM",
    "VAYUDOOTLOGISTICS.COM",
    "tcifreight.in",
    "yatayatindia.com",
    "etoltd.in",
    "cosmocarrying.com",
    "shreekarnicargo.com",
    "tvslsl.com",
    "atctrade.net",
    "toobalogistics.com",
    "2sindia.com",
    "jaibalajilogistics.in",
    "esseltransport.com",
    "sachkhandtransport.in",
    "shreejitranslogistics.com",
    "expan.co.in",
    "corelogistic.com",
    "obclimited.com",
    "kuberlogisticsindia.com",
    "transexpresslogistics.net",
    "freightx.in",
    "sirlindia.com",
    "neccgroup.com",
    "cti.in",
    "babajishivram.com",
    "nslogisticservice.com",
    "lotrucks.com",
    "shreevasulogistics.com",
    "DHTCLOGISTICS.COM",
    "subham.com",
    "blrlogistiks.com",
    "whitefieldminerals.com",
    "transportindia3pl.com",
    "barodafreightcarrier.com",
    "mtcoi.in",
    "govindkripatransport.com",
    "serl.com",
    "TRUNKPOOL.COM",
    "krltransport.com",
    "vtransgroup.com",
    "expressroadways.in",
    "sktransport.co.in",
    "msfcipl.com",
    "ltcpl.org",
    "bharatroadways.com",
    "teamtranslogistics.in",
    "tscargo.in",
    "purplelillies.in",
    "rivigo.com",
    "pcc-logistics.com",
    "rukmanitrans.com",
    "transin.in",
    "darcl.com",
    "ABCINDIA.COM",
    "vil.co.in",
    "packncarry.in",
    "transolutions.co.in",
    "transolutions.co",
    "sbr73.com",
    "mansaglobal.com",
    "TOTALLOGISTICS.IN",
    "eitain.com",
    "ambilytech.com",
    "totalgroup.in",
    "atclindia.com",
    "HANSROADCARRIERS.COM",
    "safeandsecure.in",
    "jaincarrier.com",
    "bestroadways.com",
    "truckersindia.com",
    "shreejitransport.com",
    "dpdhl.com",
    "rajprotim.com",
    "dgfc.in",
    "unitylogstics.co.in",
    "geekom.in",
    "abr.co.in",
    "nrtpl.com",
    "sical.com",
    "getl.in",
    "parasmaniroadlines.com",
    "flexus.org.in",
    "SWASTIKCARRIERS.COM",
    "mrkool.in",
    "truckola.in",
    "dgstranslogistics.com",
    "astransport.in",
    "ghgc.in",
    "LAXMIPRIVAHAN.COM",
    "PNXLOGISTICS.COM",
    "coldrushlogistics.com",
    "mahindralogistics.com",
    "supremecorporation.in",
    "anandroadlines.com",
    "unitedsafetransport.com",
    "karnatakaroadlines.com",
    "bhorukas.com",
    "dsv.com",
    "nvr-logistics.com",
    "coldex.in",
    "delex.in",
    "tslgroup.in",
    "tciexpress.in",
    "nblpl.com",
    "shriniwasa.com",
    "kshgroup.com",
    "pragtilogistics.com",
    "chartered.com",
    "scorpiongroup.in",
    "reetroadlines.com",
    "teamtranslogistics.com",
    "itrosys.com",
    "rocketbox.in",
    "meratransport.com",
    "hgrlog.com",
    "icmlogistics.co.in",
    "city-link.co.in",
    "mituj.com",
    "mahaveeratransport.com",
    "dbrcpl.com",
    "subham.biz",
    "UNILOG.NET",
    "capricornlogistics.com",
    "UTTARANCHALTRANSWAYS.COM",
    "rkvcargomovers.com",
    "ujjawallogistics.com",
    "truxapp.com",
    "ARCLIMITED.COM",
    "transexpresslogistics.com",
    "svrtlogistics.com",
    "ofbusiness.com",
    "industrialfreightmovers.com",
    "ingrammicrocommerce.com",
    "mfctransport.com",
    "RITCOGROUP.COM",
    "mppl.co",
    "jklogistics.asia",
    "SPEEDLOGIST.COM",
    "omtulsilogistics.com",
    "alps.com",
    "handagroup.in",
    "atctrade.co.in",
    "OLTS.IN",
    "katariacarriers.com",
    "g-translogistics.com",
    "m.made-in-china.com",
    "mehtaroadtransport.com",
    "coastalroadways.com",
    "roadfreightcarriers.co.in",
    "maashardalogisticindia.com",
    "tcil.com",
    "geekom.biz",
    "Linfox.com",
    "sktranslines.com",
    "regalindialogistics.com",
    "mail.totallogistics.in",
    "sgrgroup.org.in",
    "allindiatpt.com",
    "bakshitransportcarriers.com",
    "reeturoadlines.com",
    "associatedcarryingcompany.com",
    "unitylogistics.co.in",
    "pps.in",
    "superlorry.com",
    "logistictransports.com",
    "PBRPITHMAPUR.COM",
    "irclindia.com",
    // "dhl.com",
    "SRTCLOGISTICS.IN",
    "vidurlogistics.com",
    "mail.etoltd.co.in",
    "bestindianpackers.com",
    "MARUTIPARIVAHAN.COM",
    "nagpurgolden.com",
    "subhm.biz",
    "grpl.in",
    "satkabirlogistics.com",
    "hindustancargocarriers.com",
    "vrclogistics.com",
    "SAVANI-INDIA.COM",
    "drtcindia.com",
    "ato.co.in",
    "nitcologistics.com",
    "vinaycargo.com",
    "freightco.in",
    "NGTFREIGHT.COM",
    "BICLV.COM",
    "matagroup.in",
    "joycotransport.com",
    "vrcltd.com",
    "roadfreightcarriers.co",
    "safetransline.in",
    "hrc.org.in",
    "bgfcindia.com",
    "sfctransport.com",
    "prominentcargo.com",
    "gicpl.in",
    "ajlindia.com",
    "mghgroup.com",
    "efsindia.in",
    "webmail.abhinavtransindia.co.in",
    "SHUBHAMFREIGHT.COM",
    "cgppl.com",
    "VIJAYBHARATLOGISTICS.CO.IN",
    "svvhlogistics.wix.com",
    "sugamparivahan.com",
    "GANGAJAMNA.IN",
    "ecl.net",
    "lemuir.com",
    "acmroadways.com",
    "mbtranz.com",
    "rubytranslogistics.com",
    "arclimitied.com",
    "joshifreightcarriers.com",
    "nirbhaitransport.com",
    "asonic-logisticsolutions.com",
    "abhishekfreight.in",
    "abtparcelservice.com",
    "acuite.in",
    "actship.com",
    "adaniports.com",
    "adityabulk.com",
    "aeypeetransport.com",
    "agarwalpackers.com",
    "aiffc.com",
    "amarroadlines.com",
    "amitcargo.com",
    "amitroadways.com",
    "arcvns.com",
    "ankurroadlines.com",
    "asianlogisticspcl.com",
    "atlaslogistics.co.in",
    "avanalogistek.com",
    "balajitranscarriers.com",
    "baskabombay.com",
    "bmps.co.in",
    "btcmovers.in",
    "bindallogistics.com",
    "carryfastagencies.com",
    "chamundaroadlines.com",
    "chetantransportco.com",
    "chiragroadlines.com",
    "chaudharytransportcompany.com",
    "cogentscs.com",
    "concorindia.com",
    "coolhublogistics.com",
    "coolwayscarrier.com",
    "countrywidelogistics.co.in",
    "deccanqueen.net",
    "deepaktransexprress.com",
    "dlinfra.com",
    "doabaluxury.com",
    "dtscargo.com",
    "eleganttransport.in",
    "esquireworld.com",
    "fasttracklogistics.co",
    "firstflight.net",
    "freeztech.in",
    "futuresupplychains.com",
    "gagangiritransport.com",
    "ganeshlogistics.com",
    "gati.com",
    "gatikausar.com",
    "geofast.com",
    "gujaratlogistics.com",
    "hhroadways.com",
    "harekrishnalogistics.in",
    "shreekhodiyartransportco.com",
    "kerryindev.com",
    "icmap.co.in",
    "indoarya.com",
    "inlogistics.in",
    "interarchbuildings.com",
    "jamtranslogistics.com",
    "getux.in",
    "jmdts.com",
    "jayvadwalatransport.in",
    "jrvlogistics.in",
    "kdlogistics.co.in",
    "ktlgroup.in",
    "kanishkalogistics.com",
    "kelvincoldchain.com",
    "ktc.co.in",
    "kpslogistic.com",
    "le-carriers.com",
    "loadshare.net",
    "mjlsl.com",
    "maxwelllogistics.net",
    "megaltd.net",
    "middletonlogistics.com",
    "mmmlogistics.in",
    "nnsons.com",
    "nationaltransport.com",
    "nationalcarrying.co.in",
    "ncslog.com",
    "ngfc.in",
    "newmalik.com",
    "newroadlink.com",
    "shalimarroadways.com",
    "pankajroadways.com",
    "ssstp.com",
    "papersnparcels.com",
    "protrans.in",
    "pkjgroup.in",
    "main.pushpaklogistics.co.in",
    "rahultransport.com",
    "ramgrouponline.com",
    "rcpl.net.in",
    "rhenus.com",
    "rhjlogistics.com",
    "rktgroup.in",
    "rslogistics.co.in",
    "rsvglobal.co.in",
    "ruralagriventures.com",
    "smlogistic.in",
    "spcargo.co.in",
    "sadanandcarriers.com",
    "safetranslogistics.com",
    "sagarroadlines.com",
    "saikrupatransport.com",
    "saraswatitransport.com",
    "satgurucarriers.com",
    "schedulers.in",
    "sclpl.org",
    "shankerlogistics.com",
    "shivshaktitransport.in",
    "in.linkedin.com",
    "srilakshmigroupcom.wordpress.com",
    "srmt.com",
    "starexpressindia.com",
    "sfapl.com",
    "justdial.com",
    "indiamart.com",
    "superroadways.in",
    "supersafelogistics.com",
    "swiftcoldchaingroup.com",
    "tslineindia.com",
    "tez-india.com",
    "tlpllogistics.co.in",
    "tollgroup.com",
    "gainwellindia.com",
    "transcargoindia.in",
    "transafeservices.com",
    "trimurticargo.com",
    "trivedigroup.in",
    "urcpl.in",
    "unitylogistics.in",
    "vscpl.in",
    "vishabrothers.com",
    "xpeed.in",
    "yusen-logistics.com",
    "goex.in",
    "wefreight.co.in",
    "singaltransport.com",
    "jalantransport.com",
    "aaryalogistics.com",
    "abhinav-xpress.com",
    "abrlgroup.com",
    "vsnl.net",
    "mtnl.net.in",
    "altrans.in",
    "yahoo.co.iin",
    "steplogistics.in",
    "anandroadlinees.com",
    "ccrlogistics.in",
    "atoonline.co.in",
    "brl.in",
    "bhorukas.co.in",
    "btpl.net.in",
    "gobolt.co.in",
    "tcgppl.com",
    "dhtcmail.com",
    "drsindia.in",
    "etoltd.co.in",
    "expressroadways.co.in",
    "gmtransporting.com",
    "dishnetdsl.net",
    "ganeshroalines.com",
    "arllimited.com",
    "hanstrpt.com",
    "icmlogistics.com",
    "icmlmail.com",
    "ifmmail.com",
    "iwlpl.in",
    "intraglobe.co",
    "jaidurgagroup.com",
    "jkgroup.asia",
    "jfcdhule.org",
    "krlmrl.net",
    "vsnl.com",
    "kshdistriparks.com",
    "lgbls.com",
    "gmaail.com",
    "upperindia.in",
    "mhapl.net",
    "mehtatransportcorporation.com",
    "in.mghgroup.com",
    "neccgrop.com",
    "ntcgroup.in",
    "ofbusiness.in",
    "prplmail.com",
    "ritcogroup.net",
    "sslpl.in",
    "sam-transport.com",
    "savani.in",
    "seniortranslines.com",
    "shreeganeshlogistics.com",
    "shreeshipping.in",
    "ssrc.com",
    "logisticpark.biz",
    "singhgolden.com",
    "secl.net",
    "sriniketana.com",
    "subham.co.in",
    "eastwestindia.com",
    "cal3.vsnl.net.in",
    "outlook.com",
    "protonmail.com",
    "zoho.com",
    "inbox.com",
    "mail.com",
    "msn.com",
    "live.com",
    "aol.com",
    "gmx.net",
    "tii_murugappa.com",
    "emamaigroup.com",
    "total.com",
    "cargil.com",
    "mail.dabur.in",
    "berguerindia.com",
    "nsail.com",
    "gamil.com",
    ]